
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/production-services/live-streaming",
      function () {
        return require("private-next-pages/production-services/live-streaming.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/production-services/live-streaming"])
      });
    }
  